import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  href?: string;
  size?: 'default' | 'large';
  className?: string;
}
export function CTAButton({
  text,
  href = 'https://fabricaindustrial.com/cart/53066804855123:1',
  size = 'default',
  className = ''
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'text-sm md:text-base py-3 md:py-4 px-6 md:px-8' : 'text-sm py-3 px-6';
  const iconSize = size === 'large' ? 'w-4 h-4 md:w-5 md:h-5' : 'w-4 h-4';
  const handleClick = () => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart');
    }
  };
  return <a href={href} onClick={handleClick} className={`inline-flex items-center justify-center gap-2 bg-wood-grain font-bold rounded-none shadow-[0_6px_0_0_#7B4F28,0_8px_16px_0_rgba(0,0,0,0.8)] hover:shadow-[0_3px_0_0_#7B4F28,0_6px_12px_0_rgba(0,0,0,0.9)] hover:translate-y-1 transition-all duration-200 border-2 border-[#6F6F6F] uppercase tracking-wider ${sizeClasses} ${className}`} style={{
    color: '#E4D6B5'
  }} aria-label={text} data-id="element-33">
      {text}
      <ArrowRight className={iconSize} aria-hidden="true" data-id="element-34" />
    </a>;
}